<template>
  <v-card class="rounded-card">
    <v-card-title class="font-weight-bold">
      Aprovadores
    </v-card-title>
    <v-card-text class="text--primary">
      <v-simple-table
        fixed-header
      >
        <template v-slot:default>
          <thead>
          <tr>
            <th>Aprovador</th>
            <th class="text-center">Situação</th>
            <th class="text-center"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="aprovador in aprovacao.gestoresReponsaveis" :key="aprovador.id">
            <td>
              {{ aprovador.gestor.nome }}
            </td>
            <td class="text-center">
              <div>
                <px-situacao-aprovacao :situacao="aprovador.situacao"/>
              </div>
            </td>
            <td>
              <v-btn v-if="canAprove(aprovador)"
                     class="normal-btn-text rounded-tag-small elevation-0"
                     color="primary" small
                     :disabled="loadingRecusar"
                     :loading="loadingAprovar"
                     @click="aprovar">
                Aprovar
              </v-btn>
              <recusar-aprovacao-dialog v-if="canAprove(aprovador)"
                                        :aprovacao="aprovacao"
                                        @update="emitUpdate"/>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <px-confirm-dialog ref="confirm"/>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { SituacaoAprovacao } from 'px-business-components';
import AprovacaoService from '@/modules/aprovacao/aprovacao-service';
import RecusarAprovacaoDialog from '@/modules/aprovacao/detalhes/RecusarAprovacaoDialog.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingAprovar: false,
      loadingRecusar: false,
    };
  },
  computed: {
    ...mapGetters('user', ['user', 'hasRoleAprovador']),
    canAprove() {
      return aprovador => this.hasRoleAprovador
        && aprovador.gestor.id === this.user.id
        && aprovador.situacao === SituacaoAprovacao.keys.PENDENTE.key
        && this.aprovacao.situacao === SituacaoAprovacao.keys.PENDENTE.key;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    aprovar() {
      this.loadingAprovar = true;
      AprovacaoService.aprovar(this.aprovacao.id)
        .then(() => {
          this.$toast('Compra aprovada', { color: 'success' });
          this.emitUpdate();
        })
        .finally(() => {
          this.loadingAprovar = false;
        });
    },
  },
  components: { RecusarAprovacaoDialog },
};
</script>
